module.exports = __webpack_public_path__ + "static/media/niyitanga_rushaki6.72ab58ac.jpg";